import { AspectRatio } from '@sparemin/blockhead';
import React, { useState } from 'react';
import { getAspectRatioValue } from 'utils/aspect-ratio';
import { useClipSelect } from '../ClipSelectContext';
import {
  ClipSelectPreviewPlayer,
  ClipSelectPreviewPlayerProps,
} from '../ClipSelectVideoPlayer';
import { ClipSelectPreviewPlayerInstance } from '../ClipSelectVideoPlayer/ClipSelectPreviewPlayer';
import { useClipSelectDetailCardContext } from './ClipSelectDetailCardContext';
import { previewBlock as block } from './utils';

export type ClipSelectDetailCardPreviewProps = Pick<
  ClipSelectPreviewPlayerProps,
  | 'isLoading'
  | 'lastPlaybackPos'
  | 'onDestroy'
  | 'onPlaybackChange'
  | 'onReady'
  | 'onSeek'
> & {
  widgetId: string;
};

const ClipSelectDetailCardPreview = React.forwardRef<
  ClipSelectPreviewPlayerInstance,
  ClipSelectDetailCardPreviewProps
>(({ isLoading, widgetId, ...props }, ref) => {
  const { isPlaying, suggestionId } = useClipSelectDetailCardContext();

  const { clipsPageInfo } = useClipSelect({ clipId: suggestionId });

  const [playerWidgetId, setPlayerWidgetId] = useState(widgetId);

  if (widgetId && widgetId !== playerWidgetId) {
    setPlayerWidgetId(widgetId);
  }

  const aspectRatioName = clipsPageInfo?.aspectRatioName || 'square';
  const aspectRatioValue = getAspectRatioValue(aspectRatioName);

  return (
    <AspectRatio
      ratio={aspectRatioValue}
      className={block({ [aspectRatioName]: !!aspectRatioName })}
    >
      <ClipSelectPreviewPlayer
        aspectRatio={aspectRatioValue}
        isLoading={isLoading}
        isPlaying={isPlaying}
        ref={ref}
        widgetId={playerWidgetId}
        {...props}
      />
    </AspectRatio>
  );
});

export default ClipSelectDetailCardPreview;
